<template>
  <v-card
    flat
    color="transparent"
    style="margin-top: 10px; margin-bottom: 10px"
    width="1200px"
    min-height="500px"
  >
    <v-card-title class="justify-center">
      <div :style="{ fontSize: scale(23) + 'px' }">ขอหนังสือรับรองการเป็นผู้ถือกรรมสิทธิ์ในตราสารหนี้</div>
    </v-card-title>

    <!------------------------------------------ PC -------------------------------------------->
    <div v-if="!isMobile()">
      <v-card width="1200px" min-height="500px">
        <v-card-title>
          <div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลผู้ถือหุ้น
          </div>
        </v-card-title>
        <v-card-subtitle class="subtitle">
          <div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลเพื่อขอหนังสือรับรอง
          </div>
        </v-card-subtitle>
        <v-col>
          <v-sheet rounded="lg">
            <div>
              <v-text-field
                v-model="inform_cifno_show"
                label="เลขที่บัตรประชาชน (Citizen ID)"
                readonly
              ></v-text-field>
              <v-text-field
                v-model="inform_tel_show"
                label="เบอร์โทรศัพท์"
                readonly
              ></v-text-field>
              <v-row>
                <v-col cols="12" sm="3" md="2">
                  <v-text-field
                    v-model="inform_prefix"
                    label="คำนำหน้าชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="inform_name"
                    label="ชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="inform_lastname"
                    label="นามสกุล"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
            <v-divider></v-divider>
            <div :style="{ fontSize: scale(20) + 'px' }" class="mt-3">
              1. โปรดเลือกภาษาของหนังสือยืนยันยอดที่ท่านประสงค์
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-select
                  v-model="lang"
                  :items="lang_option"
                  item-text="text"
                  item-value="value"
                  label="ภาษา"
                ></v-select>
              </v-col>
            </v-row>
            <div :style="{ fontSize: scale(20) + 'px' }" class="mt-3">
              2. โปรดเลือกวัตถุประสงค์ในการขอหนังสือรับรอง
            </div>
            <v-row class="mt-0">
              <v-col cols="12" sm="12" md="4" class="py-0">
                <v-radio-group v-model="certificate_type">
                  <v-radio
                    label="ยื่นต่อหน่วยงาน"
                    value="personal"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <div v-if="isSubmitToAgency" class="mb-5">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <label>เลือกวันที่</label>
                  <span style="color: red; margin-left: 8px;">ทั้งนี้ท่านสามารถออกหนังสือรับรองฯย้อนหลังได้ไม่เกิน 3 เดือนนับจากวันปัจจุบัน</span>
                </v-col>
              </v-row>
              <v-form ref="dateForm">
                <v-row>
                  <v-col cols="12" sm="12" md="12" class="py-0">
                    <v-col cols="12" sm="12" md="6" class="pt-0">
                      <DatePicker
                        v-model="date"
                        label="วันที่"
                        clearable
                        format="DD/MM/YYYY"
                        locale="th"
                        :first-day-of-week="1"
                        @change="dateChanged"
                        :rules="dateRules"
                        :max="yesterday"
                        :min="threeMonthAgo"
                      ></DatePicker>
                    </v-col>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-divider></v-divider>
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :value="selected"
                  :items="IssuerVal"
                  :item-key="'uniqueKey'"
                  show-select
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-text': 'รายการต่อหน้า:',
                    'items-per-page-all-text': 'ทั้งหมด'
                  }"
                ></v-data-table>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-card>
      <div class="footbtn">
        <v-btn color="primary" @click="downloadFile()"> Download </v-btn>
        <v-btn
          text
          @click="goBack"
          style="position: absolute; right: 0px; margin-right: 10px"
        >
          กลับหน้าแรก
        </v-btn>
      </div>
    </div>

    <!------------------------------------------ Mobile -------------------------------------------->
    <div v-if="isMobile()">
      <!-- Mobile Version -->
      <v-card width="100%" min-height="500px">
        <v-card-title>
          <div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลผู้ถือหุ้น
          </div>
        </v-card-title>
        <v-card-subtitle class="subtitle">
          <div :style="{ fontSize: scale(20) + 'px' }">
            ข้อมูลเพื่อขอหนังสือรับรอง
          </div>
        </v-card-subtitle>
        <v-col>
          <v-sheet rounded="lg">
            <div>
              <v-text-field
                v-model="inform_cifno_show"
                label="เลขที่บัตรประชาชน (Citizen ID)"
                readonly
              ></v-text-field>
              <v-text-field
                v-model="inform_tel_show"
                label="เบอร์โทรศัพท์"
                readonly
              ></v-text-field>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="inform_prefix"
                    label="คำนำหน้าชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="inform_name"
                    label="ชื่อ"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="inform_lastname"
                    label="นามสกุล"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
            <v-divider></v-divider>
            <div :style="{ fontSize: scale(20) + 'px' }" class="mt-3">
              1. โปรดเลือกภาษาของหนังสือยืนยันยอดที่ท่านประสงค์
            </div>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="lang"
                  :items="lang_option"
                  item-text="text"
                  item-value="value"
                  label="ภาษา"
                ></v-select>
              </v-col>
            </v-row>
            <div :style="{ fontSize: scale(20) + 'px' }" class="mt-3">
              2. โปรดเลือกวัตถุประสงค์ในการขอหนังสือรับรอง
            </div>
            <v-row class="mt-0">
              <v-col cols="12" class="py-0">
                <v-radio-group v-model="certificate_type">
                  <v-radio
                    label="ยื่นต่อหน่วยงาน"
                    value="personal"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <div v-if="isSubmitToAgency" class="mb-5">
              <v-row>
                <v-col cols="12">
                  <label>เลือกวันที่</label>
                  <span style="color: red; margin-left: 8px; font-size: 12px;">ทั้งนี้ท่านสามารถออกหนังสือรับรองฯย้อนหลังได้ไม่เกิน 3 เดือนนับจากวันปัจจุบัน</span>
                </v-col>
              </v-row>
              <v-form ref="dateForm">
                <v-row>
                  <v-col cols="12" class="py-0 pt-0">
                    <DatePicker
                      v-model="date"
                      label="วันที่"
                      clearable
                      format="DD/MM/YYYY"
                      locale="th"
                      :first-day-of-week="1"
                      @change="dateChanged"
                      :rules="dateRules"
                      :max="yesterday"
                      :min="threeMonthAgo"
                    ></DatePicker>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :value="selected"
                  :items="IssuerVal"
                  :item-key="'uniqueKey'"
                  show-select
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-text': 'รายการต่อหน้า:',
                    'items-per-page-all-text': 'ทั้งหมด'
                  }"
                ></v-data-table>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-card>
      <div class="footbtn">
        <v-btn color="primary" @click="downloadFile()"> Download </v-btn>
        <v-btn
          text
          @click="goBack"
          style="position: absolute; right: 0px; margin-right: 10px"
        >
          กลับหน้าแรก
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialog" width="500">
      <v-card outlined>
        <v-card-title></v-card-title>
        <v-card-text min-height="300px" class="pb-0">
          <v-alert dense outlined type="error" class="alerttext">
            <div :style="{ fontSize: scale(16) + 'px' }">
              {{ dialogText }}
            </div>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import DatePicker from "@/components/DatePicker.vue";

export default {
  name: "certificate_PaotangVer",
  components: { DatePicker },
  data: () => ({
    today: new Date().toISOString().split("T")[0],
    yesterday: new Date(new Date().setDate(new Date().getDate() - 1))
      .toISOString()
      .split("T")[0],
    threeMonthAgo: new Date(new Date().setMonth(new Date().getMonth() - 3))
      .toISOString()
      .split("T")[0],
    dialog: false,
    dialogText: "",
    overlay: false,
    cifno: "",
    inform_cifno_show: "",
    inform_tel_show: "",
    inform_prefix: "",
    inform_name: "",
    inform_lastname: "",
    fullName: "",
    IssuerVal: [],
    selected: [],
    lang_option: [
      { text: "ภาษาไทย", value: "th" },
    ],
    lang: "th",
    date: new Date(new Date().setDate(new Date().getDate() - 1))
      .toISOString()
      .substr(0, 10),
    currency_selected: "THB",
    certificate_type: "personal",
    certificate_for: "myself",
    headers: [
      { text: "Security Symbol", value: "SECURITYSYMBOL" },
      { text: "Holder ID", value: "HOLDER_ID" },
      { text: "Unit Summary", value: "unitTxt" },
    ],
  }),
  computed: {
    ...mapGetters('Auth', ['getUserData']),
    isSubmitToAgency() {
      return this.certificate_type === "personal";
    },
    dateRules() {
      return this.isSubmitToAgency ? [(v) => !!v || "กรุณาเลือกวันที่"] : [];
    },
  },
  mounted() {
    const userData = this.getUserData;
    
    if (!userData || !userData.fromPaotang) {
      this.dialogText = "กรุณาเข้าสู่ระบบผ่านหน้าหลัก";
      this.dialog = true;
      setTimeout(() => {
        this.$router.push('/');
      }, 2000);
      return;
    }

    this.cifno = userData.refno;
    this.inform_prefix = userData.prefixname;
    this.inform_name = userData.firstname;
    this.inform_lastname = userData.lastname;
    this.fullName = `${userData.prefixname} ${userData.firstname} ${userData.lastname}`;
    
    var maskid = userData.refno;
    this.inform_cifno_show =
      maskid.substr(0, 1) +
      "-" +
      maskid.substr(1, 2) +
      "XXXXXX" +
      maskid.substr(9, 12);
    this.inform_tel_show = userData.mobile_otp;

    this.getInvestCert(this.yesterday, this.cifno, this.fullName);
  },
  methods: {
    ...mapActions('CertificatePaotang', ['GetInvestCert', 'DownloadCertificate']),
    
    isMobile() {
      return window.innerWidth < 1280;
    },
    
    scale(num) {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return (num * 60) / 100;
        case "sm":
          return (num * 70) / 100;
        case "md":
          return (num * 90) / 100;
        case "lg":
          return (num * 95) / 100;
        case "xl":
          return num;
      }
    },

    dateChanged(val) {
      console.log("Date changed:", val);
      if (val) {
        this.getInvestCert(val, this.cifno, this.fullName);
      }
    },

    getInvestCert(dateReq, refnoReq, fullnameReq) {
      this.overlay = true;
      const requestData = {
        AsofDate: dateReq,
        REFNO: refnoReq,
        FULLNAME: fullnameReq,
      };
      
      console.log("Requesting certificate data:", requestData);
      
      this.$store
        .dispatch("CertificatePaotang/GetInvestCert", requestData)
        .then((resp) => {
          if (resp != null) {
            const obj = JSON.parse(resp.data != "null" ? resp.data : "[]");
            this.IssuerVal = [];
            for (const [index, item] of Object.values(obj).entries()) {
              this.IssuerVal.push({
                ...item,
                uniqueKey: `${item.SECURITYSYMBOL}_${index}`,
                unitTxt: Number(item.UNITBALANCE).toLocaleString()
              });
            }
            
            console.log("Certificate data loaded:", this.IssuerVal);
            
            if (this.IssuerVal.length == 0) {
              this.dialogText = "ไม่พบข้อมูลการถือครองหลักทรัพย์ ณ วันที่ท่านระบุ";
              this.dialog = true;
            }
            this.selected = [];
            this.overlay = false;
          } else {
            this.IssuerVal = [];
            this.selected = [];
            this.overlay = false;
          }
        })
        .catch((err) => {
          console.error("error", err);
          this.dialogText = "ขออภัย! การเชื่อมต่อมีปัญหา";
          this.dialog = true;
          this.overlay = false;
        });
    },

    downloadFile() {
      this.overlay = true;

      if (this.isSubmitToAgency) {
        if (!this.$refs.dateForm.validate()) {
          this.dialogText = "กรุณาเลือกวันที่";
          this.dialog = true;
          this.overlay = false;
          return;
        }
      }

      const payload = {
        lang: this.lang,
        prefix: this.inform_prefix,
        first_name: this.inform_name,
        last_name: this.inform_lastname,
        date: moment(this.date).format("YYYY-MM-DD"),
        currency: this.currency_selected,
        certificate_type: this.certificate_type,
        certificate_for: this.certificate_for,
        ref_no: this.cifno,
        securities_symbol: this.selected.map((item) => item.SECURITYSYMBOL),
      };

      console.log("Download payload:", payload);

      this.$store
        .dispatch("CertificatePaotang/DownloadCertificate", payload)
        .then((resp) => {
          const blob = new Blob([resp.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;

          const disposition =
            resp.headers["content-disposition"] ||
            resp.headers["Content-Disposition"];
          let fileName = "certificate.zip";
          if (disposition && disposition.includes("filename=")) {
            fileName = disposition.split("filename=")[1].replace(/["']/g, "");
          }
          link.download = fileName;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          window.URL.revokeObjectURL(url);
          this.overlay = false;
        })
        .catch((err) => {
          console.error("Download error:", err);
          if (err.response?.status == 401) {
            this.dialogText = "หมดเวลาการทำรายการ กรุณาทำรายการใหม่";
          } else {
            this.dialogText = "ขออภัย! การเชื่อมต่อมีปัญหา";
          }
          this.dialog = true;
          this.overlay = false;
        });
    },

    goBack() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
v-sheet {
  min-height: 400px;
}
.v-card__title {
  font-size: 20px;
}
v-card-title {
  font-family: "Ktcfast";
  font-size: 20px;
}
h2,
h3,
h4 {
  font-family: "Ktcfast";
}
.subtitle,
.alerttext {
  margin-top: 5px;
  font-family: "Ktcfast";
  font-size: 20px;
}
.footbtn {
  margin-top: 10px;
}
</style>
